module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.section == 1) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "lg4": "",
      "offset-lg4": ""
    }
  }, [_c('v-card', [_c('progress-bar', {
    attrs: {
      "show": _vm.form.busy
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      },
      "keydown": function($event) {
        return _vm.form.onKeydown($event)
      }
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.$t('reset_password')))])]), _vm._v(" "), _c('v-card-text', [_c('password-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8'),
      expression: "'required|min:8'"
    }],
    ref: "password",
    attrs: {
      "form": _vm.form,
      "hint": _vm.$t('password_length_hint'),
      "v-errors": _vm.errors,
      "value": _vm.form.password,
      "name": "password"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "password", $event)
      },
      "eye": function($event) {
        _vm.eye = $event
      }
    }
  }), _vm._v(" "), _c('password-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    attrs: {
      "form": _vm.form,
      "hide": _vm.eye,
      "label": _vm.$t('confirm_password'),
      "v-errors": _vm.errors,
      "value": _vm.form.password_confirmation,
      "data-vv-as": "password",
      "hide-icon": "true",
      "name": "password_confirmation"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "password_confirmation", $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('submit-button', {
    attrs: {
      "flat": true,
      "form": _vm.form,
      "label": _vm.$t('reset_password')
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.section == 99) ? _c('div', [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n            This link is no longer valid. Please contact us if you have questions.\n          ")])], 1)], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-187a6f97","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/password/reset.vue
// module id = Ph04
// module chunks = 1